export default __webpack_public_path__ + "static/media/page-404-image.2801697d.png";